const map = {
	"./assignment.json": 50447,
	"./auth.json": 23552,
	"./common.json": 47067,
	"./course.json": 615,
	"locales/es/assignment.json": 50447,
	"locales/es/auth.json": 23552,
	"locales/es/common.json": 47067,
	"locales/es/course.json": 615
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20743;